<template>
  <div
    ref="container"
    class="custom-message-component-container"
    :style="{
      ...style,
      width,
      border
    }"
    @click="clickHandle"
  >
    <slot />
  </div>
</template>

<script lang="ts" >

import {
  CustomMessageContainerComponent,
  getJustifyContentFromAlignment,
  getAlignItemsFromAlignment,
  CustomMessageMargin,
  CustomMessagePadding,
} from '_c/typings/model/chat/text-node';
import { pushUrl, getWidth } from '@/business/chat/custom-message-util';
import { defineComponent, computed, PropType, toRaw } from 'vue';

export default defineComponent({
  name: 'CustomMessageContainer',
  props: {
    attr: {
      type: Object as PropType<CustomMessageContainerComponent>,
      required: true,
    },
  },

  setup(props) {
    let scale = 1;
    if (props?.attr?.scale) {
      scale = toRaw(props.attr.scale);
    }
    const { constraints, decoration } = toRaw(props.attr);
    const attr = toRaw(props.attr);
    let margin;
    if (!attr.margin) {
      margin = '';
    } else {
      const { left, top, bottom, right } = attr.margin as CustomMessageMargin;
      margin = `${top ? top : 0}px ${right ? right : 0}px ${bottom ? bottom : 0}px ${left ? left : 0}px`;
    }
    let padding;
    if (!attr.padding) {
      padding = '';
    } else {
      const { left, top, bottom, right } = attr.padding as CustomMessagePadding;
      padding = `${top ? top : 0}px ${right ? right : 0}px ${bottom ? bottom : 0}px ${left ? left : 0}px`;
    }
    const style = {
      height: attr.height ? `${attr.height * scale}px` : '100%',
      minWidth: constraints?.minWidth ? `${constraints.minWidth * scale}px` : '',
      minHeight: constraints?.minHeight ? `${constraints.minHeight * scale}px` : '',
      maxWidth: constraints?.maxWidth ? `${constraints.maxWidth * scale}px` : '',
      maxHeight: constraints?.maxHeight ? `${constraints.maxHeight * scale}px` : '',
      backgroundColor: decoration?.color ? '#'.concat(decoration.color.slice(4), decoration.color.slice(2, 4)) : '',
      backgroundImage: decoration?.image?.url ? `url(${decoration.image.url})` : '',
      display: attr.alignment ? 'flex' : '',
      justifyContent: getJustifyContentFromAlignment(props.attr.alignment),
      alignItems: getAlignItemsFromAlignment(props.attr.alignment),
      borderRadius: decoration?.radius ? `${decoration.radius * scale}px` : '',
      margin,
      padding,
    };

    let width = getWidth(props.attr.width, scale);
    if (!attr.width && attr.usedWidth) {
      width = 'auto';
    }
    const border = computed(() => {
      if (!props.attr?.decoration?.border) return '';
      const { width, color } = props.attr.decoration.border;
      let borderWidth;
      let borderColor;
      if (width) {
        borderWidth = (width * scale).toString();
      }
      if (color) {
        // ffbbffaa=>#bbffaaff
        borderColor = '#'.concat(color.slice(4), color.slice(2, 4));
      }
      return `${borderWidth ? borderWidth : '0'}px solid ${borderColor ? borderColor : '#00000000'}`;
    });
    function clickHandle(e: Event): void {
      if (props.attr.onClick) {
        e.stopPropagation();
        pushUrl(props.attr.onClick, props.attr.reportData);
      }
    }
    return {
      width,
      border,
      style,
      clickHandle,
    };
  },

});
</script>


